import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const purchaseHeaderSlice = createSlice({
  name: "purchaseHeader",
  initialState: {
    customer: null,
    contact: 0,
    prevNo: 0,
    BatchNo: 0,
    invo: null,
    taxNo: 0,
    vatNo: 0,
    date: dayjs().format(),
    time: dayjs().format("HH:mm:ss"),
    outlet: null,
    careOf: null,
    editMode: false,
    note: "",
    partyCrDr: "Cr",
    prevBill_partyCrDr: "",
  },
  reducers: {
    updateSelected: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetState: (state) => {
      // Reset the state to its initial/default values
      return {
        ...state,
        customer: null,
        contact: 0,
        prevNo: 0,
        BatchNo: 0,
        invo: null,
        taxNo: 0,
        vatNo: 0,
        date: dayjs().format(),
        outlet: null,
        careOf: null,
        godownWise: false,
        note: "",
      };
    },
  },
});

export const { updateSelected, resetState } = purchaseHeaderSlice.actions;
export default purchaseHeaderSlice.reducer;
